<template>
  <div class="modal fade show custom-modal modal-show" id="myModalAccept" role="dialog" v-if="showRejectModal">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="closeRejectModal()">&times;</button>
        </div>
        <div class="modal-body text-center pb-0">
          <p class="mb-0 pre-insp">Pre-Inspection Number</p>
          <p class="pinNumber mb-0">{{pinNumber}}</p>
          <p class="success">has been successfully rejected</p>
        </div>
        <div class="col-12 modal-footer pb-4">
          <button type="button" class="btn bgc-btn-primary" @click="closeRejectModal()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProceedModal",
  props:['pinNumber','showRejectModal'],
  setup(props, context){
    function closeRejectModal(){
      context.parent.closeRejectModal();
    }
    return {
      closeRejectModal
    }
  }
};
</script>

<style scoped>
.modal-body {
  overflow-y: hidden;
}
.pinNumber {
  color: #0070be;
  font-size: 20px;
  font-weight: bold;
  margin-top: -5px;
}
.pre-insp {
  color: #666666;
}
.success {
  color: #666666;
   margin-top: -5px;
}
.modal-footer {
  justify-content: center;
  border-top: 0 none;
}
</style>